import { SceneLighting } from "../common";
import { easeOutBack, easeOutCubic } from "../interpolation";
import { PieceFn } from "../PieceFn";
import { createScene } from "../sequencer";

const SCENE_DEFAULT = 0;

export const defaultLighting: SceneLighting = {
  ambient: [0.2, 0.2, 0.2],
  light1: {
    position: [0, 0, 0],
    intensity: [0.5, 0.55, 0.6],
  },
  cameraLightIntensity: [0.5, 0.55, 0.6],
  fogColor: [0.1098039216, 0.1647058824, 0.3882352941],
  fogDensity: 1.5,
};

const introFadeInOut = new PieceFn()
  .addSegment(0, 8, (t) => 1 - t)
  .addSegment(24, 32, (t) => t);

const macaroniGrow = new PieceFn()
  .addSegment(0, 14, () => 0)
  .addSegment(14, 16, (t) => easeOutCubic(t));

const macaroniRotate = new PieceFn()
  .addSegment(0, 14, () => 0)
  .addSegment(14, 16, (t) => easeOutBack(t) * Math.PI * 2);

const macaroniYOffset = new PieceFn()
  .addSegment(0, 18, (t) => Math.sin(t * 8.0 * Math.PI) * 0.05)
  .addSegment(18, 0, () => 0);

const sparkleSize = new PieceFn()
  .addSegment(0, 8, () => 0)
  .addSegment(16, 18, (t) => 1.0 - easeOutCubic(t));

export const introScene = createScene({
  name: "Intro",
  sceneId: SCENE_DEFAULT,
  length: 32,
  lighting: defaultLighting,
  shader: "intro",
  effects: {
    enable: ["vhs"],
  },
  variables: (ctx) => {
    return [
      macaroniGrow.evaluate(ctx.sceneNowInBeats),
      macaroniRotate.evaluate(ctx.sceneNowInBeats),
      macaroniYOffset.evaluate(ctx.sceneNowInBeats),
      sparkleSize.evaluate(ctx.sceneNowInBeats),
    ];
  },
});

introScene.addSequence([
  {
    length: 32,
    camera: {
      position: [0, 0, -5],
      target: [0, 0, 0],
    },
    fade: (t) => [
      0,
      0,
      0,
      introFadeInOut.evaluate(t.sceneContext.sceneNowInBeats),
    ],
  },
]);
